var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',[_c('ErrorComponent',{attrs:{"message":_vm.error,"btnTitle":"Go Back"},on:{"onClick":_vm.goToPICHome}})],1):_c('div',{staticClass:"login"},[_c('DgSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }